<template>
  <div class="row">
    <div class="col-12 col-lg-4 g">
        <div class="card card-body">
            <div class="form-group">
              <h5 for="">إختر الخدمة</h5>
              <select class="form-control text-center form-control-lg" v-model="app">
                <option value="">-- اختر --</option>
                <option v-for="a in apps" :key="a.id" :value="a.id">{{a.title}}</option>
              </select>
            </div>
            <div class="form-group">
              <h5 for="">الفترة من</h5>
              <input type="text"
                class="form-control text-center form-control-lg" v-model="from">
            </div>
            <div class="form-group">
              <h5 for="">الفترة حتى</h5>
              <input type="text"
                class="form-control text-center form-control-lg" v-model="to">
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-primary" @click="view()" v-if="!loading">
                    <i class="fa fa-search"></i>
                    عرض التقرير
                </button>
                <button class="btn btn-primary disabled" disabled v-if="loading">
                    جاري البحث...
                </button>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-8 g" v-if="orders.length && !loading">
        <div class="row">
            <div class="col-6 col-lg-4 text-center g" v-for="s in stats" :key="s.title">
                <div class="card card-body">
                    <h2>
                        {{ new Intl.NumberFormat('en-US', {
                        style: 'decimal',
                        }).format(s.value) }}
                    </h2>
                    {{ s.title }}
                </div>
            </div>
        </div>
        <div class="card card-body" style="padding: 0px;">
            <button class="btn btn-sm btn-success" @click="excel()" style="border-radius: 0px; position: absolute; top: -28px; z-index: 999">
                <i class="fa fa-file"></i>
                تصدير الى Excel
            </button>
            <div class="col-12 table-responsive" style="padding: 0px">
                <table class="table table-sm table-hover">
                    <thead>
                        <th>م</th>
                        <th>
                            رقم الطلب
                        </th>
                        <th>
                            الخدمة
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            الاجمالي
                        </th>
                        <th>
                            المبلغ
                        </th>
                        <th>
                            الضريبة
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(order, o) in orders" :key="order.order_id">
                            <td>{{o+1}}</td>
                            <td>
                                {{ order.order_id }}
                            </td>
                            <td>
                                {{ order.service ? order.service : order.plan }}
                            </td>
                            <td>
                                {{ order.date }}
                            </td>
                            <td>
                                {{ new Intl.NumberFormat('en-US', {
                                style: 'decimal',
                                }).format(order.total ? order.total : order.amount) }}
                            </td>
                            <td>
                                {{ new Intl.NumberFormat('en-US', {
                                style: 'decimal',
                                }).format(order.original) }}
                            </td>
                            <td>
                                {{ new Intl.NumberFormat('en-US', {
                                style: 'decimal',
                                }).format(order.tax) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
var XLSX = require("xlsx");
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            app: "",
            apps: [],
            from: new Date().toISOString().split("T")[0],
            to: new Date().toISOString().split("T")[0],
            orders: [],
            stats: [],
            loading: false
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/apps/list', {
            jwt: g.user.jwt,
        }).then(function(r){
            g.apps = r.response
        }) 
    },
    methods: {
        view(){
            var g = this;
            g.loading = true;
            $.post(api + '/user/apps/stats', {
                jwt: g.user.jwt,
                app: g.app,
                from: g.from,
                to: g.to
            }).then(function(r){
                g.stats = r.response.stats;
                g.orders = r.response.orders;
                g.loading = false
            }).fail(function(){
                g.loading = false;
            })
        },
        excel(){
            var g = this;
            const wb = XLSX.utils.book_new();
            const Heading = [
                [
                    "م",
                    "رقم الطلب",
                    "الخدمة",
                    "التاريخ",
                    "الاجمالي",
                    "المبلغ",
                    "الضريبة"
                ]
            ];
            var xx = [];
            g.orders.forEach(function(a, i){
                xx.push([
                    i+1,
                    a.order_id,
                    a.service ?? a.plan,
                    a.date,
                    a.total ?? a.amount,
                    a.original,
                    a.tax
                ])
            })

            // creating sheet and adding data from 2nd row of column A.
            // leaving first row to add Heading
            const ws = XLSX.utils.json_to_sheet(xx, { origin: 'A2', skipHeader: true });
                
            // adding heading to the first row of the created sheet.
            // sheet already have contents from above statement.
            XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
                
            // appending sheet with a name
            XLSX.utils.book_append_sheet(wb, ws, 'Records');
                
            const fileContent = XLSX.writeFile(wb, g.app + "_" + g.from + "_" + g.to + ".xlsx");
        }
    }
}
</script>

<style>

</style>